<template>
  <b-modal
    :id="modalId"
    :visible="value"
    hide-header
    no-close-on-backdrop
    centered
    @hide="onHide"
  >
    <div class="text-center">
      <h5 class="mb-1">{{ $t('unit.duplicate_facility_title') }}</h5>

      <p class="mb-0">
        <small>{{ $t('unit.description') }}: <strong>{{ (existing && existing.description) ? existing.description : '—' }}</strong></small>
      </p>
      <p class="mb-0">
        <small>{{ $t('unit.rems') }}: <strong>{{ rems || (existing && existing.rems) || '—' }}</strong></small>
      </p>
      <p class="mb-2">
        <small>{{ $t('unit.sirh') }}: <strong>{{ sirh || (existing && existing.sirh) || '—' }}</strong></small>
      </p>

      <p class="mt-1">
        {{ $t('unit.duplicate_facility_message') }}
      </p>
    </div>

    <template #modal-footer>
      <b-button variant="secondary" @click="emitClose">{{ $t('actions.close') }}</b-button>
      <b-button variant="outline-primary" @click="openExistingInNewTab">
        {{ $t('unit.open_existing_new_tab') }}
      </b-button>
      <b-button variant="primary" @click="$emit('create-merge-all')">
        {{ $t('unit.merge') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue';

export default {
  name: 'UnitDuplicateDialog',
  components: { BModal, BButton },

  props: {
    value: { type: Boolean, required: true },
    existing: {
      type: Object,
      default: () => null,
    },
    rems: { type: [String, Number], default: '' },
    sirh: { type: [String, Number], default: '' },
    modalId: { type: String, default: 'duplicate-rems-sirh' },
    unitsPath: { type: String, default: '#/unit' },
  },

  methods: {
    emitClose() {
      this.$emit('input', false);
      this.$emit('close');
    },
    onHide() {
      if (this.value) {
        this.$emit('input', false);
        this.$emit('close');
      }
    },
    openExistingInNewTab() {
      if (!this.existing || !this.existing.id) return;
      const url = `${window.location.origin}${this.unitsPath}?editUnitId=${this.existing.id}`;
      window.open(url, '_blank');
    },
  },
};
</script>

<style scoped>
</style>
